import { FIELDS } from './constants';

/**
 * Serializes an error message, with all the fields about the error's metadata.
 * @param {Object|Error} error
 * @return {Object}
 */
const serialize = (error) => {
    if (typeof error !== 'object' || error === null) {
        return error;
    }

    if (typeof error.toJSON === 'function') {
        return {
            ...createRecord(error),
            ...error.toJSON()
        };
    }

    if (error instanceof Error) {
        return createRecord(error);
    }

    return error;
};

/**
 * Create an object using pre defined collection of property getters
 * @param {Error|object}
 * @returns {object}
 */
function createRecord(error) {
    const record = {};

    FIELDS.forEach((field) => {
        const value = error[field];
        if (value || value === 0) {
            record[field] = value;
        }
    });

    return record;
}

export default serialize;
